import './i18n';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './App.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import App from './App';
import {Amplify} from 'aws-amplify';
import amplifyconfig from './amplifyconfiguration.json'
Amplify.configure(amplifyconfig);

const root = createRoot(document.getElementById('root'));

// root.render(
//   <ThemeProvider>
//     <App />
//   </ThemeProvider>
// );

root.render(
    <App />
);